import {
    useState,
    useEffect
} from 'react';
import {
    Container,
} from './styled';
import {
    Avatar,
    Search
} from '../../../components';


export function ImportConfigUser(props) {

    const { isOpen, users, inProgress, onClose, onClick } = props;

    const [filterUserList, setFilterUserList] = useState('');

    function onFilterUsersList(obj) {
        return obj?.nomecompleto?.toLowerCase()
            ?.includes(filterUserList?.toLowerCase())
    };

    return (
        <Container isOpen={isOpen}>
            {!(inProgress)
                ? <div>
                    <span className='title'>
                        {`Selecione um Usuário`}
                    </span>
                    <Search
                        className={`listUsers-filter`}
                        value={filterUserList}
                        onChange={(e) => setFilterUserList(e.target.value)}
                    />
                    <ul>
                        {(users?.length > 0) &&
                            users?.filter(onFilterUsersList)?.map((user) => {
                                return (
                                    <li
                                        key={`${user?.id}`}
                                        onClick={
                                            () => { onClick(user) }
                                        }
                                    >
                                        <Avatar
                                            name={user?.nomecompleto}
                                            width={'3rem'}
                                            height={'3rem'}
                                            borderRadius={`4px`}
                                        />
                                        <span>
                                            {user?.nomecompleto}
                                        </span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <button onClick={() => onClose()}>
                        {`Cancelar`}
                    </button>
                </div>
                : <div>
                    <div className='loader'>
                    </div>
                </div>
            }
        </Container>
    )
}